/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as JoinCourseRouteImport } from './routes/join-course'
import { Route as InstructorRouteImport } from './routes/instructor'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ReviewsCompletedRouteImport } from './routes/reviews/completed'
import { Route as ProjectProjectIdRouteImport } from './routes/project/$projectId'
import { Route as LtiLaunchRouteImport } from './routes/lti/launch'
import { Route as LtiDynamicRegistrationRouteImport } from './routes/lti/dynamic-registration'
import { Route as LtiDeepLinkRouteImport } from './routes/lti/deep-link'
import { Route as InstructorDashboardRouteImport } from './routes/instructor/dashboard'
import { Route as CourseCourseIdIndexRouteImport } from './routes/course/$courseId/index'
import { Route as CourseCourseIdFeedbackRouteImport } from './routes/course/$courseId/feedback'
import { Route as AssessmentAssessmentIdFeedbackRouteImport } from './routes/assessment/$assessmentId/feedback'
import { Route as InstructorCourseCourseIdIndexRouteImport } from './routes/instructor/course/$courseId/index'
import { Route as AssessmentAssessmentIdReviewIndexRouteImport } from './routes/assessment/$assessmentId/review/index'
import { Route as AssessmentAssessmentIdReviewReviewIdRouteImport } from './routes/assessment/$assessmentId/review/$reviewId'
import { Route as InstructorCourseCourseIdTeamTeamIdRouteImport } from './routes/instructor/course/$courseId/team/$teamId'
import { Route as InstructorCourseCourseIdSectionSectionIdRouteImport } from './routes/instructor/course/$courseId/section/$sectionId'
import { Route as InstructorCourseCourseIdAssessmentCreateRouteImport } from './routes/instructor/course/$courseId/assessment/create'
import { Route as InstructorCourseCourseIdProjectProjectIdIndexRouteImport } from './routes/instructor/course/$courseId/project/$projectId/index'
import { Route as InstructorCourseCourseIdAssessmentAssessmentIdIndexRouteImport } from './routes/instructor/course/$courseId/assessment/$assessmentId/index'
import { Route as InstructorCourseCourseIdAssessmentAssessmentIdReviewsRouteImport } from './routes/instructor/course/$courseId/assessment/$assessmentId/reviews'
import { Route as InstructorCourseCourseIdAssessmentAssessmentIdEditRouteImport } from './routes/instructor/course/$courseId/assessment/$assessmentId/edit'
import { Route as InstructorCourseCourseIdProjectProjectIdAssessmentCreateRouteImport } from './routes/instructor/course/$courseId/project/$projectId/assessment/create'
import { Route as InstructorCourseCourseIdProjectProjectIdAssessmentAssessmentIdIndexRouteImport } from './routes/instructor/course/$courseId/project/$projectId/assessment/$assessmentId/index'
import { Route as InstructorCourseCourseIdProjectProjectIdAssessmentAssessmentIdEditRouteImport } from './routes/instructor/course/$courseId/project/$projectId/assessment/$assessmentId/edit'
import { Route as InstructorCourseCourseIdAssessmentAssessmentIdStaffReviewUserRevieweeIdRouteImport } from './routes/instructor/course/$courseId/assessment/$assessmentId/staff-review/user/$revieweeId'
import { Route as InstructorCourseCourseIdAssessmentAssessmentIdStaffReviewTeamRevieweeTeamIdRouteImport } from './routes/instructor/course/$courseId/assessment/$assessmentId/staff-review/team/$revieweeTeamId'

const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const JoinCourseRoute = JoinCourseRouteImport.update({
  id: '/join-course',
  path: '/join-course',
  getParentRoute: () => rootRouteImport,
} as any)
const InstructorRoute = InstructorRouteImport.update({
  id: '/instructor',
  path: '/instructor',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewsCompletedRoute = ReviewsCompletedRouteImport.update({
  id: '/reviews/completed',
  path: '/reviews/completed',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectProjectIdRoute = ProjectProjectIdRouteImport.update({
  id: '/project/$projectId',
  path: '/project/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const LtiLaunchRoute = LtiLaunchRouteImport.update({
  id: '/lti/launch',
  path: '/lti/launch',
  getParentRoute: () => rootRouteImport,
} as any)
const LtiDynamicRegistrationRoute = LtiDynamicRegistrationRouteImport.update({
  id: '/lti/dynamic-registration',
  path: '/lti/dynamic-registration',
  getParentRoute: () => rootRouteImport,
} as any)
const LtiDeepLinkRoute = LtiDeepLinkRouteImport.update({
  id: '/lti/deep-link',
  path: '/lti/deep-link',
  getParentRoute: () => rootRouteImport,
} as any)
const InstructorDashboardRoute = InstructorDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => InstructorRoute,
} as any)
const CourseCourseIdIndexRoute = CourseCourseIdIndexRouteImport.update({
  id: '/course/$courseId/',
  path: '/course/$courseId/',
  getParentRoute: () => rootRouteImport,
} as any)
const CourseCourseIdFeedbackRoute = CourseCourseIdFeedbackRouteImport.update({
  id: '/course/$courseId/feedback',
  path: '/course/$courseId/feedback',
  getParentRoute: () => rootRouteImport,
} as any)
const AssessmentAssessmentIdFeedbackRoute =
  AssessmentAssessmentIdFeedbackRouteImport.update({
    id: '/assessment/$assessmentId/feedback',
    path: '/assessment/$assessmentId/feedback',
    getParentRoute: () => rootRouteImport,
  } as any)
const InstructorCourseCourseIdIndexRoute =
  InstructorCourseCourseIdIndexRouteImport.update({
    id: '/course/$courseId/',
    path: '/course/$courseId/',
    getParentRoute: () => InstructorRoute,
  } as any)
const AssessmentAssessmentIdReviewIndexRoute =
  AssessmentAssessmentIdReviewIndexRouteImport.update({
    id: '/assessment/$assessmentId/review/',
    path: '/assessment/$assessmentId/review/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AssessmentAssessmentIdReviewReviewIdRoute =
  AssessmentAssessmentIdReviewReviewIdRouteImport.update({
    id: '/assessment/$assessmentId/review/$reviewId',
    path: '/assessment/$assessmentId/review/$reviewId',
    getParentRoute: () => rootRouteImport,
  } as any)
const InstructorCourseCourseIdTeamTeamIdRoute =
  InstructorCourseCourseIdTeamTeamIdRouteImport.update({
    id: '/course/$courseId/team/$teamId',
    path: '/course/$courseId/team/$teamId',
    getParentRoute: () => InstructorRoute,
  } as any)
const InstructorCourseCourseIdSectionSectionIdRoute =
  InstructorCourseCourseIdSectionSectionIdRouteImport.update({
    id: '/course/$courseId/section/$sectionId',
    path: '/course/$courseId/section/$sectionId',
    getParentRoute: () => InstructorRoute,
  } as any)
const InstructorCourseCourseIdAssessmentCreateRoute =
  InstructorCourseCourseIdAssessmentCreateRouteImport.update({
    id: '/course/$courseId/assessment/create',
    path: '/course/$courseId/assessment/create',
    getParentRoute: () => InstructorRoute,
  } as any)
const InstructorCourseCourseIdProjectProjectIdIndexRoute =
  InstructorCourseCourseIdProjectProjectIdIndexRouteImport.update({
    id: '/course/$courseId/project/$projectId/',
    path: '/course/$courseId/project/$projectId/',
    getParentRoute: () => InstructorRoute,
  } as any)
const InstructorCourseCourseIdAssessmentAssessmentIdIndexRoute =
  InstructorCourseCourseIdAssessmentAssessmentIdIndexRouteImport.update({
    id: '/course/$courseId/assessment/$assessmentId/',
    path: '/course/$courseId/assessment/$assessmentId/',
    getParentRoute: () => InstructorRoute,
  } as any)
const InstructorCourseCourseIdAssessmentAssessmentIdReviewsRoute =
  InstructorCourseCourseIdAssessmentAssessmentIdReviewsRouteImport.update({
    id: '/course/$courseId/assessment/$assessmentId/reviews',
    path: '/course/$courseId/assessment/$assessmentId/reviews',
    getParentRoute: () => InstructorRoute,
  } as any)
const InstructorCourseCourseIdAssessmentAssessmentIdEditRoute =
  InstructorCourseCourseIdAssessmentAssessmentIdEditRouteImport.update({
    id: '/course/$courseId/assessment/$assessmentId/edit',
    path: '/course/$courseId/assessment/$assessmentId/edit',
    getParentRoute: () => InstructorRoute,
  } as any)
const InstructorCourseCourseIdProjectProjectIdAssessmentCreateRoute =
  InstructorCourseCourseIdProjectProjectIdAssessmentCreateRouteImport.update({
    id: '/course/$courseId/project/$projectId/assessment/create',
    path: '/course/$courseId/project/$projectId/assessment/create',
    getParentRoute: () => InstructorRoute,
  } as any)
const InstructorCourseCourseIdProjectProjectIdAssessmentAssessmentIdIndexRoute =
  InstructorCourseCourseIdProjectProjectIdAssessmentAssessmentIdIndexRouteImport.update(
    {
      id: '/course/$courseId/project/$projectId/assessment/$assessmentId/',
      path: '/course/$courseId/project/$projectId/assessment/$assessmentId/',
      getParentRoute: () => InstructorRoute,
    } as any,
  )
const InstructorCourseCourseIdProjectProjectIdAssessmentAssessmentIdEditRoute =
  InstructorCourseCourseIdProjectProjectIdAssessmentAssessmentIdEditRouteImport.update(
    {
      id: '/course/$courseId/project/$projectId/assessment/$assessmentId/edit',
      path: '/course/$courseId/project/$projectId/assessment/$assessmentId/edit',
      getParentRoute: () => InstructorRoute,
    } as any,
  )
const InstructorCourseCourseIdAssessmentAssessmentIdStaffReviewUserRevieweeIdRoute =
  InstructorCourseCourseIdAssessmentAssessmentIdStaffReviewUserRevieweeIdRouteImport.update(
    {
      id: '/course/$courseId/assessment/$assessmentId/staff-review/user/$revieweeId',
      path: '/course/$courseId/assessment/$assessmentId/staff-review/user/$revieweeId',
      getParentRoute: () => InstructorRoute,
    } as any,
  )
const InstructorCourseCourseIdAssessmentAssessmentIdStaffReviewTeamRevieweeTeamIdRoute =
  InstructorCourseCourseIdAssessmentAssessmentIdStaffReviewTeamRevieweeTeamIdRouteImport.update(
    {
      id: '/course/$courseId/assessment/$assessmentId/staff-review/team/$revieweeTeamId',
      path: '/course/$courseId/assessment/$assessmentId/staff-review/team/$revieweeTeamId',
      getParentRoute: () => InstructorRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/instructor': typeof InstructorRouteWithChildren
  '/join-course': typeof JoinCourseRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/instructor/dashboard': typeof InstructorDashboardRoute
  '/lti/deep-link': typeof LtiDeepLinkRoute
  '/lti/dynamic-registration': typeof LtiDynamicRegistrationRoute
  '/lti/launch': typeof LtiLaunchRoute
  '/project/$projectId': typeof ProjectProjectIdRoute
  '/reviews/completed': typeof ReviewsCompletedRoute
  '/assessment/$assessmentId/feedback': typeof AssessmentAssessmentIdFeedbackRoute
  '/course/$courseId/feedback': typeof CourseCourseIdFeedbackRoute
  '/course/$courseId/': typeof CourseCourseIdIndexRoute
  '/assessment/$assessmentId/review/$reviewId': typeof AssessmentAssessmentIdReviewReviewIdRoute
  '/assessment/$assessmentId/review/': typeof AssessmentAssessmentIdReviewIndexRoute
  '/instructor/course/$courseId/': typeof InstructorCourseCourseIdIndexRoute
  '/instructor/course/$courseId/assessment/create': typeof InstructorCourseCourseIdAssessmentCreateRoute
  '/instructor/course/$courseId/section/$sectionId': typeof InstructorCourseCourseIdSectionSectionIdRoute
  '/instructor/course/$courseId/team/$teamId': typeof InstructorCourseCourseIdTeamTeamIdRoute
  '/instructor/course/$courseId/assessment/$assessmentId/edit': typeof InstructorCourseCourseIdAssessmentAssessmentIdEditRoute
  '/instructor/course/$courseId/assessment/$assessmentId/reviews': typeof InstructorCourseCourseIdAssessmentAssessmentIdReviewsRoute
  '/instructor/course/$courseId/assessment/$assessmentId/': typeof InstructorCourseCourseIdAssessmentAssessmentIdIndexRoute
  '/instructor/course/$courseId/project/$projectId/': typeof InstructorCourseCourseIdProjectProjectIdIndexRoute
  '/instructor/course/$courseId/project/$projectId/assessment/create': typeof InstructorCourseCourseIdProjectProjectIdAssessmentCreateRoute
  '/instructor/course/$courseId/assessment/$assessmentId/staff-review/team/$revieweeTeamId': typeof InstructorCourseCourseIdAssessmentAssessmentIdStaffReviewTeamRevieweeTeamIdRoute
  '/instructor/course/$courseId/assessment/$assessmentId/staff-review/user/$revieweeId': typeof InstructorCourseCourseIdAssessmentAssessmentIdStaffReviewUserRevieweeIdRoute
  '/instructor/course/$courseId/project/$projectId/assessment/$assessmentId/edit': typeof InstructorCourseCourseIdProjectProjectIdAssessmentAssessmentIdEditRoute
  '/instructor/course/$courseId/project/$projectId/assessment/$assessmentId/': typeof InstructorCourseCourseIdProjectProjectIdAssessmentAssessmentIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/instructor': typeof InstructorRouteWithChildren
  '/join-course': typeof JoinCourseRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/instructor/dashboard': typeof InstructorDashboardRoute
  '/lti/deep-link': typeof LtiDeepLinkRoute
  '/lti/dynamic-registration': typeof LtiDynamicRegistrationRoute
  '/lti/launch': typeof LtiLaunchRoute
  '/project/$projectId': typeof ProjectProjectIdRoute
  '/reviews/completed': typeof ReviewsCompletedRoute
  '/assessment/$assessmentId/feedback': typeof AssessmentAssessmentIdFeedbackRoute
  '/course/$courseId/feedback': typeof CourseCourseIdFeedbackRoute
  '/course/$courseId': typeof CourseCourseIdIndexRoute
  '/assessment/$assessmentId/review/$reviewId': typeof AssessmentAssessmentIdReviewReviewIdRoute
  '/assessment/$assessmentId/review': typeof AssessmentAssessmentIdReviewIndexRoute
  '/instructor/course/$courseId': typeof InstructorCourseCourseIdIndexRoute
  '/instructor/course/$courseId/assessment/create': typeof InstructorCourseCourseIdAssessmentCreateRoute
  '/instructor/course/$courseId/section/$sectionId': typeof InstructorCourseCourseIdSectionSectionIdRoute
  '/instructor/course/$courseId/team/$teamId': typeof InstructorCourseCourseIdTeamTeamIdRoute
  '/instructor/course/$courseId/assessment/$assessmentId/edit': typeof InstructorCourseCourseIdAssessmentAssessmentIdEditRoute
  '/instructor/course/$courseId/assessment/$assessmentId/reviews': typeof InstructorCourseCourseIdAssessmentAssessmentIdReviewsRoute
  '/instructor/course/$courseId/assessment/$assessmentId': typeof InstructorCourseCourseIdAssessmentAssessmentIdIndexRoute
  '/instructor/course/$courseId/project/$projectId': typeof InstructorCourseCourseIdProjectProjectIdIndexRoute
  '/instructor/course/$courseId/project/$projectId/assessment/create': typeof InstructorCourseCourseIdProjectProjectIdAssessmentCreateRoute
  '/instructor/course/$courseId/assessment/$assessmentId/staff-review/team/$revieweeTeamId': typeof InstructorCourseCourseIdAssessmentAssessmentIdStaffReviewTeamRevieweeTeamIdRoute
  '/instructor/course/$courseId/assessment/$assessmentId/staff-review/user/$revieweeId': typeof InstructorCourseCourseIdAssessmentAssessmentIdStaffReviewUserRevieweeIdRoute
  '/instructor/course/$courseId/project/$projectId/assessment/$assessmentId/edit': typeof InstructorCourseCourseIdProjectProjectIdAssessmentAssessmentIdEditRoute
  '/instructor/course/$courseId/project/$projectId/assessment/$assessmentId': typeof InstructorCourseCourseIdProjectProjectIdAssessmentAssessmentIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/instructor': typeof InstructorRouteWithChildren
  '/join-course': typeof JoinCourseRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/instructor/dashboard': typeof InstructorDashboardRoute
  '/lti/deep-link': typeof LtiDeepLinkRoute
  '/lti/dynamic-registration': typeof LtiDynamicRegistrationRoute
  '/lti/launch': typeof LtiLaunchRoute
  '/project/$projectId': typeof ProjectProjectIdRoute
  '/reviews/completed': typeof ReviewsCompletedRoute
  '/assessment/$assessmentId/feedback': typeof AssessmentAssessmentIdFeedbackRoute
  '/course/$courseId/feedback': typeof CourseCourseIdFeedbackRoute
  '/course/$courseId/': typeof CourseCourseIdIndexRoute
  '/assessment/$assessmentId/review/$reviewId': typeof AssessmentAssessmentIdReviewReviewIdRoute
  '/assessment/$assessmentId/review/': typeof AssessmentAssessmentIdReviewIndexRoute
  '/instructor/course/$courseId/': typeof InstructorCourseCourseIdIndexRoute
  '/instructor/course/$courseId/assessment/create': typeof InstructorCourseCourseIdAssessmentCreateRoute
  '/instructor/course/$courseId/section/$sectionId': typeof InstructorCourseCourseIdSectionSectionIdRoute
  '/instructor/course/$courseId/team/$teamId': typeof InstructorCourseCourseIdTeamTeamIdRoute
  '/instructor/course/$courseId/assessment/$assessmentId/edit': typeof InstructorCourseCourseIdAssessmentAssessmentIdEditRoute
  '/instructor/course/$courseId/assessment/$assessmentId/reviews': typeof InstructorCourseCourseIdAssessmentAssessmentIdReviewsRoute
  '/instructor/course/$courseId/assessment/$assessmentId/': typeof InstructorCourseCourseIdAssessmentAssessmentIdIndexRoute
  '/instructor/course/$courseId/project/$projectId/': typeof InstructorCourseCourseIdProjectProjectIdIndexRoute
  '/instructor/course/$courseId/project/$projectId/assessment/create': typeof InstructorCourseCourseIdProjectProjectIdAssessmentCreateRoute
  '/instructor/course/$courseId/assessment/$assessmentId/staff-review/team/$revieweeTeamId': typeof InstructorCourseCourseIdAssessmentAssessmentIdStaffReviewTeamRevieweeTeamIdRoute
  '/instructor/course/$courseId/assessment/$assessmentId/staff-review/user/$revieweeId': typeof InstructorCourseCourseIdAssessmentAssessmentIdStaffReviewUserRevieweeIdRoute
  '/instructor/course/$courseId/project/$projectId/assessment/$assessmentId/edit': typeof InstructorCourseCourseIdProjectProjectIdAssessmentAssessmentIdEditRoute
  '/instructor/course/$courseId/project/$projectId/assessment/$assessmentId/': typeof InstructorCourseCourseIdProjectProjectIdAssessmentAssessmentIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/instructor'
    | '/join-course'
    | '/login'
    | '/register'
    | '/instructor/dashboard'
    | '/lti/deep-link'
    | '/lti/dynamic-registration'
    | '/lti/launch'
    | '/project/$projectId'
    | '/reviews/completed'
    | '/assessment/$assessmentId/feedback'
    | '/course/$courseId/feedback'
    | '/course/$courseId/'
    | '/assessment/$assessmentId/review/$reviewId'
    | '/assessment/$assessmentId/review/'
    | '/instructor/course/$courseId/'
    | '/instructor/course/$courseId/assessment/create'
    | '/instructor/course/$courseId/section/$sectionId'
    | '/instructor/course/$courseId/team/$teamId'
    | '/instructor/course/$courseId/assessment/$assessmentId/edit'
    | '/instructor/course/$courseId/assessment/$assessmentId/reviews'
    | '/instructor/course/$courseId/assessment/$assessmentId/'
    | '/instructor/course/$courseId/project/$projectId/'
    | '/instructor/course/$courseId/project/$projectId/assessment/create'
    | '/instructor/course/$courseId/assessment/$assessmentId/staff-review/team/$revieweeTeamId'
    | '/instructor/course/$courseId/assessment/$assessmentId/staff-review/user/$revieweeId'
    | '/instructor/course/$courseId/project/$projectId/assessment/$assessmentId/edit'
    | '/instructor/course/$courseId/project/$projectId/assessment/$assessmentId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/instructor'
    | '/join-course'
    | '/login'
    | '/register'
    | '/instructor/dashboard'
    | '/lti/deep-link'
    | '/lti/dynamic-registration'
    | '/lti/launch'
    | '/project/$projectId'
    | '/reviews/completed'
    | '/assessment/$assessmentId/feedback'
    | '/course/$courseId/feedback'
    | '/course/$courseId'
    | '/assessment/$assessmentId/review/$reviewId'
    | '/assessment/$assessmentId/review'
    | '/instructor/course/$courseId'
    | '/instructor/course/$courseId/assessment/create'
    | '/instructor/course/$courseId/section/$sectionId'
    | '/instructor/course/$courseId/team/$teamId'
    | '/instructor/course/$courseId/assessment/$assessmentId/edit'
    | '/instructor/course/$courseId/assessment/$assessmentId/reviews'
    | '/instructor/course/$courseId/assessment/$assessmentId'
    | '/instructor/course/$courseId/project/$projectId'
    | '/instructor/course/$courseId/project/$projectId/assessment/create'
    | '/instructor/course/$courseId/assessment/$assessmentId/staff-review/team/$revieweeTeamId'
    | '/instructor/course/$courseId/assessment/$assessmentId/staff-review/user/$revieweeId'
    | '/instructor/course/$courseId/project/$projectId/assessment/$assessmentId/edit'
    | '/instructor/course/$courseId/project/$projectId/assessment/$assessmentId'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/instructor'
    | '/join-course'
    | '/login'
    | '/register'
    | '/instructor/dashboard'
    | '/lti/deep-link'
    | '/lti/dynamic-registration'
    | '/lti/launch'
    | '/project/$projectId'
    | '/reviews/completed'
    | '/assessment/$assessmentId/feedback'
    | '/course/$courseId/feedback'
    | '/course/$courseId/'
    | '/assessment/$assessmentId/review/$reviewId'
    | '/assessment/$assessmentId/review/'
    | '/instructor/course/$courseId/'
    | '/instructor/course/$courseId/assessment/create'
    | '/instructor/course/$courseId/section/$sectionId'
    | '/instructor/course/$courseId/team/$teamId'
    | '/instructor/course/$courseId/assessment/$assessmentId/edit'
    | '/instructor/course/$courseId/assessment/$assessmentId/reviews'
    | '/instructor/course/$courseId/assessment/$assessmentId/'
    | '/instructor/course/$courseId/project/$projectId/'
    | '/instructor/course/$courseId/project/$projectId/assessment/create'
    | '/instructor/course/$courseId/assessment/$assessmentId/staff-review/team/$revieweeTeamId'
    | '/instructor/course/$courseId/assessment/$assessmentId/staff-review/user/$revieweeId'
    | '/instructor/course/$courseId/project/$projectId/assessment/$assessmentId/edit'
    | '/instructor/course/$courseId/project/$projectId/assessment/$assessmentId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRoute
  InstructorRoute: typeof InstructorRouteWithChildren
  JoinCourseRoute: typeof JoinCourseRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  LtiDeepLinkRoute: typeof LtiDeepLinkRoute
  LtiDynamicRegistrationRoute: typeof LtiDynamicRegistrationRoute
  LtiLaunchRoute: typeof LtiLaunchRoute
  ProjectProjectIdRoute: typeof ProjectProjectIdRoute
  ReviewsCompletedRoute: typeof ReviewsCompletedRoute
  AssessmentAssessmentIdFeedbackRoute: typeof AssessmentAssessmentIdFeedbackRoute
  CourseCourseIdFeedbackRoute: typeof CourseCourseIdFeedbackRoute
  CourseCourseIdIndexRoute: typeof CourseCourseIdIndexRoute
  AssessmentAssessmentIdReviewReviewIdRoute: typeof AssessmentAssessmentIdReviewReviewIdRoute
  AssessmentAssessmentIdReviewIndexRoute: typeof AssessmentAssessmentIdReviewIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join-course': {
      id: '/join-course'
      path: '/join-course'
      fullPath: '/join-course'
      preLoaderRoute: typeof JoinCourseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/instructor': {
      id: '/instructor'
      path: '/instructor'
      fullPath: '/instructor'
      preLoaderRoute: typeof InstructorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reviews/completed': {
      id: '/reviews/completed'
      path: '/reviews/completed'
      fullPath: '/reviews/completed'
      preLoaderRoute: typeof ReviewsCompletedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/project/$projectId': {
      id: '/project/$projectId'
      path: '/project/$projectId'
      fullPath: '/project/$projectId'
      preLoaderRoute: typeof ProjectProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lti/launch': {
      id: '/lti/launch'
      path: '/lti/launch'
      fullPath: '/lti/launch'
      preLoaderRoute: typeof LtiLaunchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lti/dynamic-registration': {
      id: '/lti/dynamic-registration'
      path: '/lti/dynamic-registration'
      fullPath: '/lti/dynamic-registration'
      preLoaderRoute: typeof LtiDynamicRegistrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lti/deep-link': {
      id: '/lti/deep-link'
      path: '/lti/deep-link'
      fullPath: '/lti/deep-link'
      preLoaderRoute: typeof LtiDeepLinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/instructor/dashboard': {
      id: '/instructor/dashboard'
      path: '/dashboard'
      fullPath: '/instructor/dashboard'
      preLoaderRoute: typeof InstructorDashboardRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/course/$courseId/': {
      id: '/course/$courseId/'
      path: '/course/$courseId'
      fullPath: '/course/$courseId/'
      preLoaderRoute: typeof CourseCourseIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/course/$courseId/feedback': {
      id: '/course/$courseId/feedback'
      path: '/course/$courseId/feedback'
      fullPath: '/course/$courseId/feedback'
      preLoaderRoute: typeof CourseCourseIdFeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assessment/$assessmentId/feedback': {
      id: '/assessment/$assessmentId/feedback'
      path: '/assessment/$assessmentId/feedback'
      fullPath: '/assessment/$assessmentId/feedback'
      preLoaderRoute: typeof AssessmentAssessmentIdFeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/instructor/course/$courseId/': {
      id: '/instructor/course/$courseId/'
      path: '/course/$courseId'
      fullPath: '/instructor/course/$courseId/'
      preLoaderRoute: typeof InstructorCourseCourseIdIndexRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/assessment/$assessmentId/review/': {
      id: '/assessment/$assessmentId/review/'
      path: '/assessment/$assessmentId/review'
      fullPath: '/assessment/$assessmentId/review/'
      preLoaderRoute: typeof AssessmentAssessmentIdReviewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assessment/$assessmentId/review/$reviewId': {
      id: '/assessment/$assessmentId/review/$reviewId'
      path: '/assessment/$assessmentId/review/$reviewId'
      fullPath: '/assessment/$assessmentId/review/$reviewId'
      preLoaderRoute: typeof AssessmentAssessmentIdReviewReviewIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/instructor/course/$courseId/team/$teamId': {
      id: '/instructor/course/$courseId/team/$teamId'
      path: '/course/$courseId/team/$teamId'
      fullPath: '/instructor/course/$courseId/team/$teamId'
      preLoaderRoute: typeof InstructorCourseCourseIdTeamTeamIdRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/instructor/course/$courseId/section/$sectionId': {
      id: '/instructor/course/$courseId/section/$sectionId'
      path: '/course/$courseId/section/$sectionId'
      fullPath: '/instructor/course/$courseId/section/$sectionId'
      preLoaderRoute: typeof InstructorCourseCourseIdSectionSectionIdRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/instructor/course/$courseId/assessment/create': {
      id: '/instructor/course/$courseId/assessment/create'
      path: '/course/$courseId/assessment/create'
      fullPath: '/instructor/course/$courseId/assessment/create'
      preLoaderRoute: typeof InstructorCourseCourseIdAssessmentCreateRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/instructor/course/$courseId/project/$projectId/': {
      id: '/instructor/course/$courseId/project/$projectId/'
      path: '/course/$courseId/project/$projectId'
      fullPath: '/instructor/course/$courseId/project/$projectId/'
      preLoaderRoute: typeof InstructorCourseCourseIdProjectProjectIdIndexRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/instructor/course/$courseId/assessment/$assessmentId/': {
      id: '/instructor/course/$courseId/assessment/$assessmentId/'
      path: '/course/$courseId/assessment/$assessmentId'
      fullPath: '/instructor/course/$courseId/assessment/$assessmentId/'
      preLoaderRoute: typeof InstructorCourseCourseIdAssessmentAssessmentIdIndexRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/instructor/course/$courseId/assessment/$assessmentId/reviews': {
      id: '/instructor/course/$courseId/assessment/$assessmentId/reviews'
      path: '/course/$courseId/assessment/$assessmentId/reviews'
      fullPath: '/instructor/course/$courseId/assessment/$assessmentId/reviews'
      preLoaderRoute: typeof InstructorCourseCourseIdAssessmentAssessmentIdReviewsRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/instructor/course/$courseId/assessment/$assessmentId/edit': {
      id: '/instructor/course/$courseId/assessment/$assessmentId/edit'
      path: '/course/$courseId/assessment/$assessmentId/edit'
      fullPath: '/instructor/course/$courseId/assessment/$assessmentId/edit'
      preLoaderRoute: typeof InstructorCourseCourseIdAssessmentAssessmentIdEditRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/instructor/course/$courseId/project/$projectId/assessment/create': {
      id: '/instructor/course/$courseId/project/$projectId/assessment/create'
      path: '/course/$courseId/project/$projectId/assessment/create'
      fullPath: '/instructor/course/$courseId/project/$projectId/assessment/create'
      preLoaderRoute: typeof InstructorCourseCourseIdProjectProjectIdAssessmentCreateRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/instructor/course/$courseId/project/$projectId/assessment/$assessmentId/': {
      id: '/instructor/course/$courseId/project/$projectId/assessment/$assessmentId/'
      path: '/course/$courseId/project/$projectId/assessment/$assessmentId'
      fullPath: '/instructor/course/$courseId/project/$projectId/assessment/$assessmentId/'
      preLoaderRoute: typeof InstructorCourseCourseIdProjectProjectIdAssessmentAssessmentIdIndexRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/instructor/course/$courseId/project/$projectId/assessment/$assessmentId/edit': {
      id: '/instructor/course/$courseId/project/$projectId/assessment/$assessmentId/edit'
      path: '/course/$courseId/project/$projectId/assessment/$assessmentId/edit'
      fullPath: '/instructor/course/$courseId/project/$projectId/assessment/$assessmentId/edit'
      preLoaderRoute: typeof InstructorCourseCourseIdProjectProjectIdAssessmentAssessmentIdEditRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/instructor/course/$courseId/assessment/$assessmentId/staff-review/user/$revieweeId': {
      id: '/instructor/course/$courseId/assessment/$assessmentId/staff-review/user/$revieweeId'
      path: '/course/$courseId/assessment/$assessmentId/staff-review/user/$revieweeId'
      fullPath: '/instructor/course/$courseId/assessment/$assessmentId/staff-review/user/$revieweeId'
      preLoaderRoute: typeof InstructorCourseCourseIdAssessmentAssessmentIdStaffReviewUserRevieweeIdRouteImport
      parentRoute: typeof InstructorRoute
    }
    '/instructor/course/$courseId/assessment/$assessmentId/staff-review/team/$revieweeTeamId': {
      id: '/instructor/course/$courseId/assessment/$assessmentId/staff-review/team/$revieweeTeamId'
      path: '/course/$courseId/assessment/$assessmentId/staff-review/team/$revieweeTeamId'
      fullPath: '/instructor/course/$courseId/assessment/$assessmentId/staff-review/team/$revieweeTeamId'
      preLoaderRoute: typeof InstructorCourseCourseIdAssessmentAssessmentIdStaffReviewTeamRevieweeTeamIdRouteImport
      parentRoute: typeof InstructorRoute
    }
  }
}

interface InstructorRouteChildren {
  InstructorDashboardRoute: typeof InstructorDashboardRoute
  InstructorCourseCourseIdIndexRoute: typeof InstructorCourseCourseIdIndexRoute
  InstructorCourseCourseIdAssessmentCreateRoute: typeof InstructorCourseCourseIdAssessmentCreateRoute
  InstructorCourseCourseIdSectionSectionIdRoute: typeof InstructorCourseCourseIdSectionSectionIdRoute
  InstructorCourseCourseIdTeamTeamIdRoute: typeof InstructorCourseCourseIdTeamTeamIdRoute
  InstructorCourseCourseIdAssessmentAssessmentIdEditRoute: typeof InstructorCourseCourseIdAssessmentAssessmentIdEditRoute
  InstructorCourseCourseIdAssessmentAssessmentIdReviewsRoute: typeof InstructorCourseCourseIdAssessmentAssessmentIdReviewsRoute
  InstructorCourseCourseIdAssessmentAssessmentIdIndexRoute: typeof InstructorCourseCourseIdAssessmentAssessmentIdIndexRoute
  InstructorCourseCourseIdProjectProjectIdIndexRoute: typeof InstructorCourseCourseIdProjectProjectIdIndexRoute
  InstructorCourseCourseIdProjectProjectIdAssessmentCreateRoute: typeof InstructorCourseCourseIdProjectProjectIdAssessmentCreateRoute
  InstructorCourseCourseIdAssessmentAssessmentIdStaffReviewTeamRevieweeTeamIdRoute: typeof InstructorCourseCourseIdAssessmentAssessmentIdStaffReviewTeamRevieweeTeamIdRoute
  InstructorCourseCourseIdAssessmentAssessmentIdStaffReviewUserRevieweeIdRoute: typeof InstructorCourseCourseIdAssessmentAssessmentIdStaffReviewUserRevieweeIdRoute
  InstructorCourseCourseIdProjectProjectIdAssessmentAssessmentIdEditRoute: typeof InstructorCourseCourseIdProjectProjectIdAssessmentAssessmentIdEditRoute
  InstructorCourseCourseIdProjectProjectIdAssessmentAssessmentIdIndexRoute: typeof InstructorCourseCourseIdProjectProjectIdAssessmentAssessmentIdIndexRoute
}

const InstructorRouteChildren: InstructorRouteChildren = {
  InstructorDashboardRoute: InstructorDashboardRoute,
  InstructorCourseCourseIdIndexRoute: InstructorCourseCourseIdIndexRoute,
  InstructorCourseCourseIdAssessmentCreateRoute:
    InstructorCourseCourseIdAssessmentCreateRoute,
  InstructorCourseCourseIdSectionSectionIdRoute:
    InstructorCourseCourseIdSectionSectionIdRoute,
  InstructorCourseCourseIdTeamTeamIdRoute:
    InstructorCourseCourseIdTeamTeamIdRoute,
  InstructorCourseCourseIdAssessmentAssessmentIdEditRoute:
    InstructorCourseCourseIdAssessmentAssessmentIdEditRoute,
  InstructorCourseCourseIdAssessmentAssessmentIdReviewsRoute:
    InstructorCourseCourseIdAssessmentAssessmentIdReviewsRoute,
  InstructorCourseCourseIdAssessmentAssessmentIdIndexRoute:
    InstructorCourseCourseIdAssessmentAssessmentIdIndexRoute,
  InstructorCourseCourseIdProjectProjectIdIndexRoute:
    InstructorCourseCourseIdProjectProjectIdIndexRoute,
  InstructorCourseCourseIdProjectProjectIdAssessmentCreateRoute:
    InstructorCourseCourseIdProjectProjectIdAssessmentCreateRoute,
  InstructorCourseCourseIdAssessmentAssessmentIdStaffReviewTeamRevieweeTeamIdRoute:
    InstructorCourseCourseIdAssessmentAssessmentIdStaffReviewTeamRevieweeTeamIdRoute,
  InstructorCourseCourseIdAssessmentAssessmentIdStaffReviewUserRevieweeIdRoute:
    InstructorCourseCourseIdAssessmentAssessmentIdStaffReviewUserRevieweeIdRoute,
  InstructorCourseCourseIdProjectProjectIdAssessmentAssessmentIdEditRoute:
    InstructorCourseCourseIdProjectProjectIdAssessmentAssessmentIdEditRoute,
  InstructorCourseCourseIdProjectProjectIdAssessmentAssessmentIdIndexRoute:
    InstructorCourseCourseIdProjectProjectIdAssessmentAssessmentIdIndexRoute,
}

const InstructorRouteWithChildren = InstructorRoute._addFileChildren(
  InstructorRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRoute,
  InstructorRoute: InstructorRouteWithChildren,
  JoinCourseRoute: JoinCourseRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  LtiDeepLinkRoute: LtiDeepLinkRoute,
  LtiDynamicRegistrationRoute: LtiDynamicRegistrationRoute,
  LtiLaunchRoute: LtiLaunchRoute,
  ProjectProjectIdRoute: ProjectProjectIdRoute,
  ReviewsCompletedRoute: ReviewsCompletedRoute,
  AssessmentAssessmentIdFeedbackRoute: AssessmentAssessmentIdFeedbackRoute,
  CourseCourseIdFeedbackRoute: CourseCourseIdFeedbackRoute,
  CourseCourseIdIndexRoute: CourseCourseIdIndexRoute,
  AssessmentAssessmentIdReviewReviewIdRoute:
    AssessmentAssessmentIdReviewReviewIdRoute,
  AssessmentAssessmentIdReviewIndexRoute:
    AssessmentAssessmentIdReviewIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
